import store from '@/store/store';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import { LocalizacaoPontoUnidade, ResponseEnviaMarcacao, VinculoPontoUnidade } from '@/views/RegistroPontoNovo/types-registro-ponto';
import MarcacaoRepository from '../offline/repository/MarcacaoRepository';
import { format } from 'date-fns';

export default class RegistroPontoController {
  public static async getVinculosDoGestorAndPerfilRegPntMlt(
    showLoading: boolean = true,
    timeout: number = null,
  ): Promise<any[]> {
    const route = 'getVinculosDoGestorAndPerfilRegPntMlt';
    const nrOrg: string = store.getters.user.nrorg;
    const nrPeriodo: string = store.state.periodoDemonstrativoAtual.NRPERIODOAPURACAO;
    const nrEstrutura: string = store.getters.estruturaGerencialAtual.NRESTRUTURAM;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRPERIODOAPURACAO: nrPeriodo,
      NRESTRUTURAM: nrEstrutura,
    };

    const response = await HttpRequest.get(route, params, showLoading, null, true, null, timeout);
    ExpectedError.throwResponseError(response);
    const vinculos: any[] = response.data.dataset.data;

    return vinculos;
  }

  public static async enviaMarcacao(
    almoco: boolean,
    vinculo: VinculoPontoUnidade,
    picture: string,
    localizacao: LocalizacaoPontoUnidade,
    showLoading: boolean = true,
  ): Promise<ResponseEnviaMarcacao> {
    const route = almoco ? 'registraMarcacaoAlmocoHcmServices' :  'registraMarcacaoHcmServices';
    const nrOrg: string = store.getters.user.nrorg;
    const cdOperador: string = store.getters.user.cdoperador;

    const params = {
      requestType: 'Row',
      row: {
        NRVINCULOM: vinculo.NRVINCULOM,
        NRCPFPESSOA: vinculo.NRCPFPESSOA,
        CDOPERADOR: cdOperador,
        DSLATITUDE: localizacao.latitude,
        DSLONGITUDE: localizacao.longitude,
        DSPATH: picture || '',
        NRORG: nrOrg,
      },
    };

    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);
    return response.data.dataset.data;
  }

  public static async enviaMarcacaoOffline(
    almoco: boolean,
    vinculo: VinculoPontoUnidade,
    picture: string,
    localizacao: LocalizacaoPontoUnidade,
    showLoading: boolean = true,
  ): Promise<ResponseEnviaMarcacao> {
    const nmvinculom = vinculo.NMVINCULOM ? vinculo.NMVINCULOM : 'Não Encontrado';
    const latitude = localizacao.latitude ? String(localizacao.latitude) : '0';
    const longitude = localizacao.longitude ? String(localizacao.longitude) : '0';
    const dataHora = format(new Date(), 'dd/MM/yyyy HH:mm:ss');
    const idAlmoco = almoco ? 'S' : 'N';

    const marcacao = {
      NRCHAVEVINCULO: vinculo.NRVINCULOM.toString(),
      NMVINCULOM: nmvinculom,
      DTHRMARCACAOPONTO: dataHora,
      IDALMOCO: idAlmoco,
      DSLATITUDE: latitude,
      DSLONGITUDE: longitude,
      DSPATH: picture,
      DSERROMARCACAO: ''
    };

    return await MarcacaoRepository.setMarcacao(marcacao);
  }
}
